import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import parse from 'html-react-parser';

import IconMove from './img/move.svg'
import Fail from './img/Fail.svg'
import Pass from './img/Pass.svg'
import {CloseButton} from '@learningblocks/shared-components';
import {Button} from '@learningblocks/shared-components';

import Control from './img/Control.svg'
import ControlFilled from './img/Control-filled.svg'

import DNTPs from './img/dNTPs.svg'
import Taq_DNA_polymerase from './img/Taq_DNA_Polymerase.svg'
import Forward_primer from './img/Forward_Primer.svg'
import Reverse_primer from './img/Reverse_Primer.svg'
import Primer_Mix_of_Primers_1_and_6 from './img/Primer_Mix_of_Primers_1_and_6.svg'
import Primer_Mix_of_Primers_2_and_5 from './img/Primer_Mix_of_Primers_2_and_5.svg'
import Primer_Mix_of_Primers_3_and_4 from './img/Primer_Mix_of_Primers_3_and_4.svg'
import Buffer from './img/Buffer.svg'
import GENE_X_normal_length_control_DNA from './img/Gene_X_Normal_Length_Control_DNA.svg'
import GENE_X_shorter_length_control_DNA from './img/Gene_X_Shorter_Length_Control_DNA.svg'
import Bacterial_control_DNA from './img/Bacterial_Control_DNA.svg'
import DNase_free_water from './img/DNase_Free_Water.svg'
import Extracted_human_DNA from './img/Extracted_Human_DNA.svg'
import Control_1_thermocycler from './img/Control_1_Thermocycler.svg'
import Control_2_thermocycler from './img/Control_2_Thermocycler.svg'
import Control_3_thermocycler from './img/Control_3_Thermocycler.svg'
import Control_4_thermocycler from './img/Control_4_Thermocycler.svg'
import Sample_thermocycler from './img/Sample_Thermocycler.svg'
import Master_mix from './img/Master_Mix.svg'

const ImageList = {
  Control: Control,
  ControlFilled: ControlFilled,
  dNTPs: DNTPs,
  Taq_DNA_polymerase: Taq_DNA_polymerase,
  Forward_primer: Forward_primer,
  Reverse_primer: Reverse_primer,
  Primer_Mix_of_Primers_1_and_6: Primer_Mix_of_Primers_1_and_6,
  Primer_Mix_of_Primers_2_and_5: Primer_Mix_of_Primers_2_and_5,
  Primer_Mix_of_Primers_3_and_4: Primer_Mix_of_Primers_3_and_4,
  Buffer: Buffer,
  GENE_X_normal_length_control_DNA: GENE_X_normal_length_control_DNA,
  GENE_X_shorter_length_control_DNA: GENE_X_shorter_length_control_DNA,
  Bacterial_control_DNA: Bacterial_control_DNA,
  DNase_free_water: DNase_free_water,
  Extracted_human_DNA: Extracted_human_DNA,
  Control_1_thermocycler: Control_1_thermocycler,
  Control_2_thermocycler: Control_2_thermocycler,
  Control_3_thermocycler: Control_3_thermocycler,
  Control_4_thermocycler: Control_4_thermocycler,
  Sample_thermocycler: Sample_thermocycler,
  Master_mix: Master_mix,
}

const OPTION_ID = 'optionID';

export function ReagentItem(props){

  const onClick = (event) => {
    event.preventDefault();
    props.setAsNextStep(props.id);
  };
  const dragStart = (event) => {
    event.dataTransfer.setData(OPTION_ID, props.id);
  };

  const getImage = (component, type) => {
    return (
      <div className={"graphics" + " " + component} style={{textAlign: "center"}}>
        <img draggable={true} style={{cursor: 'move'}} onDragStart={dragStart} src={ImageList[type.replaceAll(" ", "_")]} alt={type}/>
      </div>
    )
  }

  return(
    <li>
      <div className="moveButton" style={{cursor: 'pointer'}} onClick={()=>props.addControlItem(props.id)}>
        <img src={IconMove}
          style={{ color: 'white', height: '16px', position: 'absolute', top: '-2px', right: '5px' }}
        />
      </div>
      {getImage("solution", props.type)}
      <p tabIndex={0}>{parse(props.fullName)}</p>
    </li>
  )
}
ReagentItem.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  addControlItem: PropTypes.function
};

export function ReagentDragDrop(props) {

  const [controlContents, setControlContents] = useState([]);
  useEffect(()=>{
    setSubmitted(false)
  }, [controlContents])
  const [submitted, setSubmitted] = useState(false);

  const dragOver = (event) => {
    event.preventDefault();
  };

  const dropOption = (event) => {
    event.preventDefault();
    const componentID = parseInt(event.dataTransfer.getData(OPTION_ID));

    addControlItem(componentID)
  };

  const removeControlItem = (itemID) => {
    setControlContents(controlContents.filter((x)=>{
      return x !== itemID
    }));
  }

  const addControlItem = (itemID) => {
    if(!controlContents.includes(itemID)){
      setControlContents([...controlContents, itemID]);
    }
  }

  const getFeedback = (controlContents) => {
    let response = "";
    let correct = false;

    if(
      controlContents.length === props.dragdrop.length ||
      (
        (
          controlContents.includes(1) &&
          controlContents.includes(2) &&
          controlContents.includes(3) &&
          controlContents.includes(4) &&
          controlContents.includes(5) &&
          controlContents.includes(9)
        ) && (
          (controlContents.includes(6) && controlContents.includes(7)) ||
          (controlContents.includes(6) && controlContents.includes(8)) ||
          (controlContents.includes(6) && controlContents.includes(10)) ||
          (controlContents.includes(7) && controlContents.includes(8)) ||
          (controlContents.includes(7) && controlContents.includes(10)) ||
          (controlContents.includes(8) && controlContents.includes(10))
        )
      )
    ){
      //If they have too many reagent (used all possible ingredients) or they have used two DNA samples
      response = "Oops, you have too many reagents here for a positive control. You only need one DNA sample to serve as a template."
    } else if(
      (
        !controlContents.includes(1) ||
        !controlContents.includes(2) ||
        !controlContents.includes(3) ||
        !controlContents.includes(4) ||
        !controlContents.includes(5) ||
        !controlContents.includes(9)
      ) ||
      (
        !controlContents.includes(6) &&
        !controlContents.includes(7) &&
        !controlContents.includes(8) &&
        !controlContents.includes(10)
      )
    ){
      //If they omitted one of the reagent necessary for PCR
      correct = false;
      response = "You do not have all the reagents necessary for a polymerase chain reaction to occur. Please add some more reagents into your tube. Use the components in the sample tube for comparison."
    } else if(controlContents.includes(10)){
      //If they used the extracted DNA instead of the GENE X control DNA
      correct = false;
      response = "You have selected the same reagents as what will go into your experimental sample. A positive control is one with a known positive outcome."
    } else if(controlContents.includes(7)){
      //If they use the homozygous mutant GENE X control DNA
      correct = false;
      response = "Yes, this is the reagent for one of the positive controls. But since there can be two different sizes of PCR product two positive controls are needed. The goal of positive control 1 is to amplify the full length <i>GENE X</i>."
    } else if(controlContents.includes(8)){
      //If they used the prokaryotic control DNA instead of the GENE X control DNA
      correct = false;
      response = "You have selected a DNA template that does not contain <i>GENE X</i>. A positive control is one with a known positive outcome."
    } else if(controlContents.includes(6)){
      //If they use the homozygous normal GENE X control DNA
      correct = true;
      response = "Yes, these are the correct reagents for positive control 1. Reminder, since there can be two different sizes of PCR product one long, one short – two positive controls are needed."
    } else {
      // Edge cases not accounted for
      correct = false;
      response = "Generic response."
    }

    return (
      <div className={(correct)?"correct":"incorrect"} style={{
        display: "flex",
        flexDirection: "row",
        height: "auto",
        border: ((correct)?"1px solid #84be60":"1px solid #ed3431"),
        borderRadius: "5px",
        marginTop: "8px"
      }}>
        <div style={{
          background: ((correct)?"#84be60":"#ed3431"),
          width: "100px",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <img src={(correct)?Pass:Fail} alt="" style={{
            width: "100%"
          }}/>
        </div>
        <p style={{padding: "8px", margin: 0}}>{parse(response)}</p>
      </div>
    );
  }

  return(
    <div className={props.className}>
      <p style={{
        margin: "0 0 4px 0",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "uppercase"
      }}>Reagent drag-and-drop</p>
      <p style={{fontSize: "18px", marginTop: 0}} tabIndex={0}>{parse(props.text)}</p>
      <div className="dragdropWrapper" onDragOver={dragOver}>
        <div className="reagentsList">
          <ul>
            {props.dragdrop.map((item, index)=>(
              <ReagentItem id={item.props.id} type={item.props.type} fullName={item.props.fullName} addControlItem={addControlItem} />
            ))}
          </ul>
        </div>
        <div className="reagentDropZone" onDrop={dropOption}>
          <p>Drag-and-drop here</p>
          <div className="graphics solution" style={{textAlign: "center"}}>
            <img style={{height: "100px"}} src={(controlContents.length <= 0)?ImageList["Control"]:ImageList["ControlFilled"]} />
          </div>
          <p>Normal, full-length <i>GENE X</i> control tube:</p>
          <ul style={{listStyle: "none", padding: "0 4px"}}>
            {controlContents.map((item, index)=>(
              <li
                style={{
                  padding: "2px",
                  background: "#002F50",
                  borderRadius: "3px",
                  marginTop: "4px",
                  fontSize: "14px",
                  color: "white"
                }}>
                <div style={{position: 'relative'}}>
                  <CloseButton close={(e)=>removeControlItem(item)} className={"remove-reagent"} />
                </div>
                {props.dragdrop[props.dragdrop.findIndex((x) => (x.props.id === item))].props.type}
                </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="feedbackWrapper">
        {
          (submitted)?getFeedback(controlContents):null
        }
      </div>
      <div style={{textAlign: "right", marginTop: "16px"}}>
        <Button disabled={submitted} className='submitReagents' onClick={(e)=>setSubmitted(true)}>
          Submit
        </Button>
      </div>
    </div>
  )

}
ReagentDragDrop.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  dragdrop: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ReagentDragDrop.defaultProps = {
  className: 'reagentDragDrop',
};
